import React, { Fragment } from "react";
import './css/style.css';
import AppRoutes from "./AppRoutes";
const BrowserRouter = require("react-router-dom").BrowserRouter;
function App() {
  return (
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
  );
}
export default App;
